import { CheckIcon, ExclamationCircleIcon, TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { deleteData } from "../backend";
import { useModal, WorkflowContext } from "../contexts";
import useUser from "../hooks/useUser";
import { BLOCK_ICON_MAP } from "../utils";
import LoadingModal from "./LoadingModal";

function WorkflowOverviewBlockAiEnrichment() {
  const isValidBlock = true; // TODO: Check if there are documents in the workflow

  const { openModal, closeModal } = useModal();

  const { t } = useTranslation();
  const history = useHistory();

  const { url } = useRouteMatch();

  const { hasPermission } = useUser();

  const { workflow, mutateWorkflow } = useContext(WorkflowContext);
  // const { aiEnrichment } = workflow;

  function handleOpenBlock() {
    history.push(url + "/ai-enrichment")
  }

  async function removeBlock(e: React.MouseEvent) {
    e.stopPropagation();

    try {
      openModal(<LoadingModal title={t("Deleting Block")} subtitle={t("Please wait as this may take a moment.")} />);
      await deleteData(`/workflows/ai-enrichments/${workflow.aiEnrichment!.id}/`);
    } catch (error) {
      console.error(error);
    } finally {
      await mutateWorkflow();
      closeModal();
    }
  }

  return (
    <>
      <style>{HOLO_FOIL_STYLES}</style>
      <button className={`holo-foil relative flex flex-shrink-0 items-center justify-start px-8 py-8 bg-white border border-gray-300 cursor-pointer group rounded shadow w-[600px]`} onClick={handleOpenBlock}>
        <div className="pointer-events-none absolute inset-0 rounded overflow-hidden">
          <div className="holo-foil__rainbow absolute inset-0" />
          <div className="holo-foil__shine absolute inset-0" />
        </div>
        {isValidBlock
          ? <CheckIcon className="flex-shrink-0 w-6 h-6 mr-8 p-1 bg-green text-white rounded-full" />
          : <ExclamationCircleIcon className="flex-shrink-0 w-6 h-6 mr-8 bg-yellow text-white rounded-full" />
        }
        <img src={BLOCK_ICON_MAP["AI_ENRICHMENT"]} alt="AI Enrichment icon" className="w-12 h-12 flex-shrink-0 mr-8" />
        <div className="flex flex-col w-full overflow-hidden mr-4">
          <p className="text-sm text-gray-400 whitespace-nowrap overflow-ellipsis overflow-hidden text-start">
            {t("AI Enrichment")}
          </p>
          <h3 className={"font-gilroy font-semibold whitespace-nowrap overflow-ellipsis overflow-hidden text-start " + (isValidBlock ? "text-gray-500" : "text-yellow")}>
            {t("Generate document suggestions")}
          </h3>
        </div>
        {hasPermission(workflow.team, "workflows.edit") &&
          <div className="hidden group-hover:flex justify-center items-center text-white w-6 h-6 absolute -top-2 -right-2 bg-gray-400 hover:bg-red rounded-full shadow-md" onClick={removeBlock}>
            <TrashIcon className="w-4 h-4" />
          </div>
        }
      </button>
    </>
  );
}

const HOLO_FOIL_STYLES = `
  .holo-foil__rainbow {
    background: linear-gradient(115deg, transparent 15%, rgba(255,0,128,0.18) 28%, rgba(255,200,0,0.18) 40%, rgba(0,255,170,0.18) 52%, rgba(0,160,255,0.18) 64%, rgba(170,0,255,0.18) 76%, transparent 88%);
    background-size: 300% 300%;
    mix-blend-mode: multiply;
    animation: holo-foil-drift 6s ease-in-out infinite;
  }
  .holo-foil__shine {
    background: linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.8) 50%, transparent 60%);
    background-size: 250% 100%;
    background-position: 150% 0;
    transition: background-position 0.8s ease;
  }
  @keyframes holo-foil-drift {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  @media (prefers-reduced-motion: reduce) {
    .holo-foil__rainbow { animation: none; }
    .holo-foil__shine { transition: none; }
  }
`;

export default WorkflowOverviewBlockAiEnrichment;
